// extracted by mini-css-extract-plugin
export const tabContent = "tabStyles-module--tabContent--2SZp-";
export const tabsContainer = "tabStyles-module--tabsContainer--1TMsK";